// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:59:55

export default {
  "id": "horror-forest-bear",
  "slug": "horror-forest-bear",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8622c7f82e7a41bd9eaaf64c9caa46df-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8622c7f82e7a41bd9eaaf64c9caa46df/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Horror Forest Bear",
      "description": "Imagine an angry bear that has escaped from its cave in the forest. It's very hungry and wants to eat honey. You must help the bear. The bear is starving, and it needs to eat all the honey. You need to be very careful—it's a dark and dangerous forest, full of traps and hunters. The hunters have become much stronger because they can shoot with guns now. You must avoid the hunters. Escape from them, collect all the honey, and return to the bear's cave.",
      "instructions": "Use the \"WASD\" keys to move.\nPlayable on both mobile and PC.\nDouble jump is available.\nEat all the honey, avoid the hunters, and safely return to the cave.",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "1player",
        "2d",
        "animal",
        "minecraft",
        "pixel"
      ]
    },
    "zh-CN": {
      "title": "恐怖森林熊",
      "description": "想象一只愤怒的熊从森林中的洞穴逃了出来。它非常饿，想吃蜂蜜。你必须帮助这只熊。熊已经饿极了，需要吃掉所有的蜂蜜。你必须非常小心——这是一个黑暗且危险的森林，充满了陷阱和猎人。猎人们变得更强大了，因为他们现在可以开枪射击。你必须避开猎人。逃离他们，收集所有的蜂蜜，然后返回熊的洞穴。",
      "instructions": "使用“WASD”键进行移动。\n可在手机和PC上玩。\n可进行双跳。\n吃掉所有蜂蜜，避开猎人，安全返回洞穴。",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "1玩家",
        "2D",
        "动物",
        "我的世界",
        "像素"
      ]
    },
    "zh-TW": {
      "title": "驚悚森林熊",
      "description": "想像一隻逃出森林洞穴的生氣熊。它非常餓，想要吃蜂蜜。你必須幫助這隻熊。熊已經餓得要命，它需要吃掉所有的蜂蜜。你必須非常小心——這是一個黑暗且危險的森林，充滿陷阱和獵人。因為他們現在可以拿槍射擊，所以獵人變得強大許多。你必須避免獵人。逃離他們，收集所有的蜂蜜，並回到熊的洞穴。",
      "instructions": "使用\"WASD\"鍵盤移動。\n可在手機和PC上遊玩。\n可進行雙重跳躍。\n吃掉所有的蜂蜜，避免獵人，並安全返回洞穴。",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "1人遊玩",
        "2D",
        "動物",
        "Minecraft",
        "像素"
      ]
    },
    "zh-HK": {
      "title": "驚悚森林熊",
      "description": "想像一隻逃離森林洞穴的怒熊。它非常餓，想吃蜂蜜。你必須幫助這隻熊。熊非常餓，它需要吃掉所有蜂蜜。你必須非常小心——這是一個黑暗而危險的森林，充滿陷阱和獵人。因為他們現在可以拿槍射擊，獵人變得非常強大。你必須避開獵人。逃離他們，收集所有蜂蜜，並回到熊的洞穴。",
      "instructions": "使用「WASD」鍵盤移動。\n適用於手機及電腦平台。\n可進行雙重跳躍。\n吃掉所有蜂蜜，避免獵人，安全回到洞窟。",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "1人玩",
        "2D",
        "動物",
        "Minecraft",
        "像素"
      ]
    },
    "ja": {
      "title": "ホラーフォレストベア",
      "description": "森の中の洞窟から逃げ出した怒っている熊を想像してみなさい。それはとてもお腹が空いており、蜂蜜を食べたいと思っています。熊を助ける必要があります。熊は飢えており、すべての蜂蜜を食べる必要があります。とても慎重にする必要があります——それは暗くて危険な森で、罠や狩人で満ちています。狩人は銃を使えるようになり、とても強くなりました。狩人を避ける必要があります。彼らから逃げ、すべての蜂蜜を集め、熊の洞窟に戻らなければなりません。",
      "instructions": "\"WASD\"キーを使用して移動してください。\nモバイルとPCの両方でプレイ可能です。\nダブルジャンプが使用できます。\nすべてのハチミツを食べ、狩人を避け、安全に洞窟に戻ってください。",
      "genres": [
        "アギリティ",
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "動物",
        "マインクラフト",
        "ピクセル"
      ]
    },
    "ko": {
      "title": "호러 포레스트 범",
      "description": "임산의 곰이 숲 속의 동굴에서 탈출했어요. 그는 매우 배고파서 꿀을 먹고 싶어요. 곰을 도와야 해요. 곰은 굶주린 상태예요, 모든 꿀을 먹어야 해요. 매우 조심해야 해요—그것은 어둡고 위험한 숲이에요, 유괴와 사냥꾼들이 가득하죠. 사냥꾼들은 총을 쏠 수 있어서 훨씬 강해졌어요. 사냥꾼을 피해야 해요. 그들에서 도망쳐 모든 꿀을 모아서 곰의 동굴로 돌아가세요.",
      "instructions": "\"WASD\" 키를 사용하여 이동하세요.\n모바일과 PC 모두에서 플레이 가능합니다.\n퀵 점프가 사용 가능합니다.\n모든 꿀을 먹고 사냥꾼을 피하고 안전하게 동굴로 돌아가세요.",
      "genres": [
        "순수성",
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "동물",
        "마인크래프트",
        "픽셀"
      ]
    },
    "fr": {
      "title": "Forêt de l'horreur ours",
      "description": "Imaginez un ours en colère qui a échappé de sa grotte dans la forêt. Il est très affamé et veut manger du miel. Vous devez aider l'ours. L'ours est affamé, et il doit manger tout le miel. Vous devez être très prudent—c'est une forêt sombre et dangereuse, pleine de pièges et de chasseurs. Les chasseurs sont devenus beaucoup plus forts parce qu'ils peuvent tirer avec des fusils. Vous devez éviter les chasseurs. Évitez-les, collectez tout le miel, et retournez dans la grotte de l'ours.",
      "instructions": "Utilisez les touches \"WASD\" pour vous déplacer.\nJouable sur mobile et PC.\nLe double saut est disponible.\nMangez toute la miellat, évitez les chasseurs et retournez en toute sécurité dans la grotte.",
      "genres": [
        "Agilité",
        "Occasionnel"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "animal",
        "Minecraft",
        "pixel"
      ]
    }
  }
};
